import { Timestamp } from "firebase/firestore";

const ONE_DAY_IN_MILLIS = 24 * 60 * 60 * 1000;

// T is a number in days:
export function getTimestampForTPlus(numberOfDays: number): Timestamp {
  return Timestamp.fromMillis(Date.now() + numberOfDays * ONE_DAY_IN_MILLIS);
}
